<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="班级资料"
      id-key="ClassId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="reset"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="学期名称" prop="TermId">
              <el-select v-model="data.TermId" size="mini" @change="termChange" :style="isMB?'width:200px':''">
                <el-option v-for="item in termList" :key="item.TermId" :value="item.TermId" :label="item.TermName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="年级" prop="Grade">
              <el-select v-model="data.GradeId" size="mini" @change="gradeChange" :style="isMB?'width:200px':''">
                <el-option v-for="item in gradeList" :key="item.GradeId" :value="item.GradeId" :label="item.Grade"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="班级" prop="Class">
              <el-input size="mini" v-model="data.Class" placeholder="请填写班级" :style="isMB?'width:200px':''"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="班主任" prop="TeacherId">
              <el-input size="mini" v-model="data.TeacherName" @focus="onTeacherDialog" readonly placeholder="点击选择" :style="isMB?'width:200px':''"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="序号" prop="SerialNumber">
              <el-input-number :min="0" v-model="data.SerialNumber"></el-input-number>
              <!-- <span class="t-tips">值越小排得越前</span> -->
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <teacher-dialog ref="teacherDialog" in-dialog selectable :multiple="false" @select="setTeacher" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import termApi from "@/api/ed/term";
import teacherDialog from "@/components/sys/teacher/listDialog"

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    teacherDialog,
  },
  data() {
    return {
      data: {
        ClassId: 0,
        GradeId: null,
        Grade: "",
        Class: "",
        TeacherId: null,
        TeacherName: "",
        TermId: null,
        TermNumber: "",
        SerialNumber: 1,
      },
      api: require("@/api/ed/class").default,
      gradeApi: require("@/api/ed/grade").default,
      termApi,
      isMB: this.$store.state.isMB,
      gradeList: [],
      termList: [],
      rules: {
        Grade: [{ required: true, message: "请填写年级" }],
        Class: [{ required: true, message: "请填写班级" }],
        TermId: [{ required: true, message: "请选择学期" }],
        TeacherId: [{ required: true, message: "请选择班主任" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.getOption()
    },
    onEditOpened() {
      this.getOption()
    },
    getMaxNumber(tid,gid) {
      this.api.getMaxNumber(tid,gid).then(res => {
        this.data.SerialNumber = res.Data
      })
    },
    getOption() {
      this.gradeApi.list().then(res => {
        this.gradeList = res.Data || []
      })
      this.termApi.list().then(res => {
        this.termList = res.Data || []
        this.data.TermId = Number(sessionStorage.getItem("termId"))
        this.data.TermNumber = sessionStorage.getItem("termNumber")
      })
    },
    onBeforeSave() {
      if(!this.data.TermId) {
        this.$message.error("请选择学期")
        return false
      }
      if(!(this.data.SerialNumber >= 0 && this.data.SerialNumber %1 == 0)) {
        this.$message.error("序号需为不小于0的整数")
        return false
      }
    },
    gradeChange(i) {
      this.gradeList.forEach(e => {
        if(e.GradeId == i) {
          this.data.Grade = e.Grade
        }
      })
      this.getMaxNumber(this.data.TermId,i)
    },
    termChange(e) {
      sessionStorage.setItem("termId",e)
      let t = this.termList.find((x) => {
        if(e == x.TermId) {
          return x
        }
      })
      this.data.TermNumber = t.TermNumber
      if(this.data.GradeId) {
        this.getMaxNumber(e,this.data.GradeId)
      }
    },
    onTeacherDialog() {
      this.$refs.teacherDialog.open().then((that) => {
        that.getData();
      });
    },
    setTeacher(t) {
      this.data.TeacherId = t.TeacherId
      this.data.TeacherName = t.TeacherName
    },
    onTermDialog() {
      this.$refs.termDialog.open().then((that) => {
        that.getData();
      });
    },
    reset() {
      this.data.TermId = null
    }
  },
};
</script>
<style lang="scss">
</style>